"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapBedbankToCode = void 0;
const bedbankDictionary = {
    AVRHP: '1',
    ATI_HP: '2',
    BON_HP: '3',
    EUTO: '4',
    EUTOURS: '4',
    HOBHP: '5',
    HOBHPO: '5',
    HOBHPW: '5',
    HOBHPWO: '5',
    JVW_HP: '6',
    MEET: '7',
    OTCH: '8',
    OTCU: '8',
    NOVANTAHP: '9',
    W2M: '10',
    'HOPL 010': '11',
    'HOPL 020': '11',
    'HOPL 011': '11',
    'HOPL 016': '11',
    'HOPL 017': '11',
};
function mapBedbankToCode(bedbank) {
    return bedbankDictionary[bedbank] || undefined;
}
exports.mapBedbankToCode = mapBedbankToCode;
//# sourceMappingURL=mapBedbankToCode.js.map